export const portfolioAnalyticsKeys = {
  /** Use to target all portfolio analytics data in the cache */
  all() {
    return ["portfolioAnalytics"] as const
  },

  /** Use to target device status by organization data in cache */
  deviceStatusByOrganization({ orgId }: { orgId: string }) {
    return [...this.all(), "deviceStatusByOrganization", orgId] as const
  },

  /** Use to target device status by specific homegroup ID data in cache */
  deviceStatusByHomegroupId({
    orgId,
    homegroupId,
  }: {
    orgId: string
    homegroupId: string
  }) {
    return [
      ...this.all(),
      "deviceStatusByHomegroupId",
      orgId,
      homegroupId,
    ] as const
  },

  /** Use to target wifi health by organization data in cache */
  wifiHealthByOrganization({ orgId }: { orgId: string }) {
    return [...this.all(), "wifiHealthByOrganization", orgId] as const
  },

  integrationsCoveragePerIntegration({ orgId }: { orgId: string }) {
    return [...this.all(), "integrationsCoveragePerIntegration", orgId] as const
  },
} as const
